import React from 'react';

const COLORS = {
  red: '#ef4444', amb: '#f59e0b', grn: '#10b981',
  blu: '#3b82f6', pur: '#8b5cf6',
};

export default function Gauge({ score, color = 'amb', size = 180, compact = false }) {
  const sz = compact ? 80 : size;
  const cx = sz / 2;
  const cy = sz * 0.53;
  const r  = sz * 0.42;
  const sw = sz * 0.065;
  const circumference = Math.PI * r;
  const pct    = Math.max(0, Math.min(100, score)) / 100;
  const offset = circumference * (1 - pct);
  const angle  = 180 - pct * 180;
  const rad    = (angle * Math.PI) / 180;
  const nx = cx + r * 0.82 * Math.cos(rad);
  const ny = cy - r * 0.82 * Math.sin(rad);
  const c  = COLORS[color] || COLORS.amb;
  const id = `g-${color}-${sz}`;

  return (
    <svg width={sz} height={sz * 0.58} viewBox={`0 0 ${sz} ${sz * 0.58}`} role="img" aria-label={`Gauge: ${score}`}>
      <defs>
        <linearGradient id={id} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%"   stopColor="#10b981" />
          <stop offset="45%"  stopColor="#f59e0b" />
          <stop offset="100%" stopColor="#ef4444" />
        </linearGradient>
        <filter id={`glow-${id}`}>
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>

      {/* Track */}
      <path
        d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
        fill="none"
        stroke="rgba(42,48,68,.8)"
        strokeWidth={sw}
        strokeLinecap="round"
      />
      {/* Fill */}
      <path
        d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
        fill="none"
        stroke={`url(#${id})`}
        strokeWidth={sw}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        filter={`url(#glow-${id})`}
        style={{ transition: 'stroke-dashoffset .65s ease' }}
      />
      {/* Needle */}
      <line
        x1={cx} y1={cy}
        x2={nx} y2={ny}
        stroke={c}
        strokeWidth={2}
        strokeLinecap="round"
        style={{ transition: 'all .65s ease' }}
        filter={`url(#glow-${id})`}
      />
      <circle cx={cx} cy={cy} r={5} fill={c} style={{ filter: `drop-shadow(0 0 4px ${c}80)` }} />

      {/* Labels */}
      <text x={cx - r + 2} y={cy + 14} fill="rgba(107,115,148,.6)" fontSize={9} fontFamily="JetBrains Mono">0</text>
      <text x={cx - 6}     y={sz * 0.1} fill="rgba(107,115,148,.6)" fontSize={9} fontFamily="JetBrains Mono">50</text>
      <text x={cx + r - 18} y={cy + 14} fill="rgba(107,115,148,.6)" fontSize={9} fontFamily="JetBrains Mono">100</text>
    </svg>
  );
}
